export default {"src":"/_next/static/media/arrowDown.cc6e324b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};